import { createContext, useContext } from 'react'
import { OrderGroupDetailQuery } from '../../../gql/graphql'
import { ItemOfEntityResponse } from '../../../lib/RequestUtils'

export interface OrderGroupDetailContextType {
  orderGroup: ItemOfEntityResponse<OrderGroupDetailQuery> | null
}

const defaultOrderGroupDetail: OrderGroupDetailContextType = {
  orderGroup: null,
}

export const useOrderGroupDetailContext = () => {
  return useContext(OrderGroupDetailContext)
}

export const OrderGroupDetailContext = createContext<OrderGroupDetailContextType>(defaultOrderGroupDetail)
